import React, { useContext } from "react";
import { HotelContext } from "../../../context/HotelContext";
import { translate } from "../../../utils/Translation";
import "./LoadingIndicator.css";

const LoadingIndicator = () => {
  const { lang } = useContext(HotelContext);

  return (
    <div className="card-loading">
      <div className="card-loading__dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p className="card-loading__text">{translate("v2_loading", lang)}</p>
    </div>
  );
};

export default LoadingIndicator;
